import React from 'react';

type Props = {
  name: string;
  role?: string;
  company?: string;
  eventTitle: string
}
export default function TestimonialFooter({name, role, company, eventTitle}: Props) {
  return (
    <div className="mt-4 sm:mt-8 text-xs sm:text-base">
      <span className="font-bold">{name}</span>
      {(company || role) &&
        <span> • {role} {(company && role) && <>at</>} {company}</span>
      }
      <span className="text-gray font-normal"> • Training «{eventTitle}»</span>
    </div>
  );
}
